import { combineEpics, createEpicMiddleware } from "redux-observable";
import HomeEpics from "./home/epics";
export const rootEpic = combineEpics(HomeEpics);

export default createEpicMiddleware();
